export default __webpack_public_path__ + "static/media/Demolition_hauling.bc1862c7.png";